<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <Breadcrumbs headline="Sổ ghi đầu bài" :link="[{ text: 'Sổ ghi đầu bài', href: '/teachingReport' }]" />
    </div>

    <v-card outlined class="pa-6 mx-4 mb-6 elevation-0" :key="hash">
      <TeachingReportFilter @onFilterChanged="onFilterChanged" />
    </v-card>

    <v-card
      v-if="!isRefresh"
      class="d-flex flex-column align-center justify-center mx-md-4 my-md-4 elevation-0 py-16"
      outlined
    >
      <span class="mt-4"> Vui lòng cung cấp thông tin Lớp học, sau đó ấn [Tìm kiếm] để xem Sổ ghi đầu bài </span>
    </v-card>
    <v-card v-else outlined class="mx-4 mb-6 elevation-0">
      <div class="pa-4">
        Tuần từ ngày:
        <span class="font-weight-bold">
          {{ startWeek | ddmm }}
        </span>
        đến
        <span class="font-weight-bold">
          {{ endWeek | ddmm }}
        </span>
      </div>
      <v-divider></v-divider>
      <div class="pa-4">
        <TeachingReportTable :isClassShown="hash === '#teacher'" />
      </div>
    </v-card>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import { mapState, mapGetters, mapActions } from 'vuex'
import { get, orderBy } from 'lodash'
import TeachingReportFilter from '@/modules/teachingReport/TeachingReportFilter.vue'
import moment from 'moment'

export default {
  components: {
    Breadcrumbs,
    TeachingReportFilter,
    TeachingReportTable: () => import('@/modules/teachingReport/TeachingReportTable.vue'),
  },
  data() {
    return {
      isRefresh: false,
      slotHasValueList: [],
      moment: moment,
      hash: '',
    }
  },
  watch: {
    $route: {
      handler(newVal, oldVal) {
        const oHash = get(oldVal, 'hash')
        const nHash = get(newVal, 'hash')
        if (oHash != nHash) {
          this.isRefresh = false
          this.slotHasValueList = []
        }
        this.hash = nHash
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState('TeachingReport', ['loading', 'totalItems', 'classNotes', 'pageText']),
    ...mapGetters('TeachingReport', ['startWeek', 'endWeek']),
    ...mapState('timeTable', ['classSlots', 'slots']),
  },
  mounted() {},
  methods: {
    ...mapActions('TeachingReport', ['setDate', 'searchTeachingReport', 'requestPageSettings', 'fetchData']),
    ...mapActions('timeTable', ['fetchClassSlots', 'fetchClassSchedule', 'fetchScheduleClassNoteDetail']),

    async onFilterChanged(data) {
      const isTeacherFilter = this.$route.hash === '#teacher'
      console.log(isTeacherFilter)
      this.$loading.active = true

      try {
        this.setDate(data.date)
        const dateGte = this.startWeek
        const dateLte = this.endWeek
        this.isRefresh = true
        const classSlotParams = { class: data.class }
        if (isTeacherFilter) classSlotParams['teacher'] = data.teacher
        await this.fetchClassSlots(classSlotParams)

        let slotHasValueList = []
        Object.values(this.classSlots).map(slot => {
          if (get(slot, 'classNotes.length')) {
            const filteredClassNotes = slot.classNotes.filter(cn => {
              if (moment(cn.date).isSameOrAfter(dateGte) && moment(cn.date).isSameOrBefore(dateLte)) return cn
            })
            if (get(filteredClassNotes, 'length')) {
              filteredClassNotes.map(classNote =>
                slotHasValueList.push({
                  ...slot,
                  classNote,
                })
              )
            }
          }
        })
        slotHasValueList = orderBy(slotHasValueList, ['classNote.date', 'index'], ['asc'])
        this.slotHasValueList = slotHasValueList

        // mapping
        await this.fetchClassSchedule(classSlotParams)
        let allSlots = { ...this.slots }

        for (const item of slotHasValueList) {
          allSlots[`${item.index}-${item.day}`].slot = item
        }
        await this.fetchScheduleClassNoteDetail(allSlots)
      } catch (error) {
        console.error(error)
        this.$alert.error(error)
      } finally {
        this.$loading.active = false
      }
    },
  },
}
</script>
